// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/InstagramAccounts_ExchangeTokenResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /instagram/accounts/exchange_token
 *
 * Returns one or more Instagram accounts that the user authorized — currently
 * always a single-element list keyed off the access_token's owning user. The
 * list shape preserves room for future multi-account flows without breaking
 * the frontend.
 */
import type { InstagramAccounts_ExchangeTokenAccountRow } from './InstagramAccounts_ExchangeTokenAccountRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface InstagramAccounts_ExchangeTokenResponseDados {
accounts: InstagramAccounts_ExchangeTokenAccountRow[]
}

export type InstagramAccounts_ExchangeTokenResponse = ApiResponse<InstagramAccounts_ExchangeTokenResponseDados>;

registerResponseContract('InstagramAccounts_ExchangeTokenResponse', {
  accounts: {
    type: 'array',
    required: true,
    items: {
      ig_user_id:          { type: 'string',  required: true },
      ig_username:         { type: 'string',  required: true },
      profile_picture_url: { type: 'string',  required: false },
      access_token:        { type: 'string',  required: true },
    },
  },
})
